import { Component, OnInit, ViewChild } from '@angular/core';
import { FdChipCollectionComponent } from 'src/app/components/fd-chip-collection/fd-chip-collection.component';
import * as TextConstants from '../../../../constants/text.constants';
import { FilterRequestMecsModel } from 'src/app/models/mecs-models/filter-request-mecs.model';
import { HomeService } from 'src/app/services/home.service';
import { AddChipModel } from 'src/app/models/add-chip.model';
import { ActivatedRoute, Router } from '@angular/router';
import { RegionService } from 'src/app/services/region.service';
import { REGION_MAP_ICON_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/region-page/configurations/region-configuration';
import { GetMecsGlobalCountriesDataResponseModel } from 'src/app/models/mecs-models/get-mecs-global-countries-data-response.model';
import { TOP_COUNTRIES_COLORS_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/fertility-home-page/configurations/top-countries-colors';
import { color } from 'html2canvas/dist/types/css/types/color';
import { MecsRegionalSolutionsLaunchPhaseModel } from 'src/app/models/mecs-models/mecs-regional-solutions-laynch-phase.model';
import { COUNTRY_COLOR_CONFIGURATION } from './configurations/country-color-configuration';

@Component({
  selector: 'app-mecs-dashboard-regional',
  templateUrl: './mecs-dashboard-regional.component.html',
  styleUrls: ['./mecs-dashboard-regional.component.scss'],
})
export class MecsDashboardRegionalComponent implements OnInit {
  @ViewChild(FdChipCollectionComponent)
  fdChipCollectionComponent!: FdChipCollectionComponent;
  regionMapIconsCongig = REGION_MAP_ICON_CONFIGURATION;

  textConstants = TextConstants;
  showSpinner = false;

  regionData: any = {
    regionName: '',
    iconUrl: '',
    implementationStatus: {
      numberOfCountries: 0,
      countriesLaunchPhase: 0,
      countriesPreLaunchPhase: 0,
      overallInternalNPS: 0,
      solutionReuquests: 0,
    },
    topCountries: [],
    globalOverview: [],
  };

  filterOptions: FilterRequestMecsModel = {
    startDate: null,
    endDate: null,
    countries: [],
    regions: [],
    solutions: [],
    phases: [],
  };
  regionId!: number;

  countriesData: GetMecsGlobalCountriesDataResponseModel = {
    implementationStatus: {
      numberOfCountries: 0,
      countriesLaunchPhase: 0,
      countriesPreLaunchPhase: 0,
      overallInternalNPS: 0,
      solutionReuquests: 0,
    },
    topCountries: [],
    globalOverview: [],
  };

  countriesColors = COUNTRY_COLOR_CONFIGURATION;

  currentPageGlobalOverview = 1;
  itemsPerPageGlobalOverview = 4;

  solutionPhaseData: MecsRegionalSolutionsLaunchPhaseModel[] = [];

  isCountryFilterRemoved = false;
  isKpiFilterRemoved = false;

  constructor(
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private regionService: RegionService
  ) {}

  ngOnInit(): void {
    this.showSpinner = true;

    const idParam = this.route.snapshot.paramMap.get('id');
    this.regionId = idParam ? +idParam : 0;
    this.filterOptions.regions = [this.regionId];

    this.getCountriesData();

    this.getFilterOptions();

    this.getMecsRegionalSolutionLaunchPhase();
  }

  getMecsRegionalSolutionLaunchPhase() {
    this.regionService.getMecsRegionalSolutionLaunchPhase(this.filterOptions).subscribe((result) => {
      const phaseColorMap: { [key: string]: string } = {
        contacted: '#9D96C9',
        'pre-launch': '#EB3C96',
        launch: '#0F69AF',
        contact: '#503291',
      };
  
      const assignedCountryColors = new Set<string>();
  
      const getRandomColor = (): string => {
        let availableColors = this.countriesColors.filter(color => !assignedCountryColors.has(color));
        if (availableColors.length === 0) {
          assignedCountryColors.clear();
          availableColors = [...this.countriesColors];
        }
        const color = availableColors[Math.floor(Math.random() * availableColors.length)];
        assignedCountryColors.add(color);
        return color;
      };
  
      this.solutionPhaseData = result.map(phase => {
        const phaseColor = phaseColorMap[phase.phase.toLowerCase()] || '#D7D5D6';
  
        const coloredCountries = phase.countries.map(country => ({
          ...country,
          color: getRandomColor()
        }));
  
        return {
          ...phase,
          color: phaseColor,
          countries: coloredCountries
        };
      });
      this.showSpinner = false;
    });
  }
  

  getFilterOptions() {
    this.regionService
      .getMecsRegionFilterOptions(this.regionId)
      .subscribe((result) => {
        this.regionData = result;

        this.regionData.regionName = this.regionData.regionName.toUpperCase();
        this.regionData.iconUrl =
          this.regionMapIconsCongig.find(
            (x) =>
              x.regionName?.toLowerCase() ===
              this.regionData.regionName?.toLowerCase()
          )?.iconUrl ?? null;
      });
  }

  getFilterData(e: any) {
    this.filterOptions = e;
    this.isCountryFilterRemoved = true;
    this.isKpiFilterRemoved = false;

    this.getCountriesData();

    this.getMecsRegionalSolutionLaunchPhase();
  }

  getCountriesData() {
    this.homeService
      .getMecsGlobalCountriesData(this.filterOptions)
      .subscribe((result) => {
        this.countriesData = result;
      });
  }

  addChipToCollection(chipData: AddChipModel): void {
    this.fdChipCollectionComponent.addChip(chipData);
  }

  filterByCountry(){
    this.isKpiFilterRemoved = true;
    this.isCountryFilterRemoved = false;
    this.filterOptions.startDate = null;
    this.filterOptions.endDate = null;
    this.filterOptions.regions = [this.regionId];
    this.filterOptions.solutions = [];
    this.filterOptions.phases = [];
    this.filterOptions.countries = this.fdChipCollectionComponent?.chips.map(x => x.id) ?? [];
    
    this.getCountriesData();

    this.getMecsRegionalSolutionLaunchPhase();
  }

  get paginatedGlobalOverview() {
    const start =
      (this.currentPageGlobalOverview - 1) * this.itemsPerPageGlobalOverview;
    return this.countriesData.globalOverview.slice(
      start,
      start + this.itemsPerPageGlobalOverview
    );
  }

  get totalPagesGlobalOverview() {
    return Math.ceil(
      this.countriesData.globalOverview.length / this.itemsPerPageGlobalOverview
    );
  }

  get pagesGlobalOverview(): number[] {
    return Array.from(
      { length: this.totalPagesGlobalOverview },
      (_, i) => i + 1
    );
  }

  goToPageGlobalOverivew(page: number) {
    if (page >= 1 && page <= this.totalPagesGlobalOverview) {
      this.currentPageGlobalOverview = page;
    }
  }
}
